import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath, ToggleRevealItemContext } from '@uswitch/spark.utils';
import React, { useContext } from 'react';
import AnimateHeight from 'react-animate-height';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var accordionPanelVariantPath = getVariantPath({
  id: 'accordion',
  element: 'accordionPanel'
})();
var AccordionPanel = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      extraPadding = _ref.extraPadding,
      props = _objectWithoutProperties(_ref, ["children", "extraPadding"]);

  var _useContext = useContext(ToggleRevealItemContext),
      isOpen = _useContext.isOpen;

  return _jsx(AnimateHeight, _objectSpread(_objectSpread({
    "data-spark-accordion-content": true,
    duration: 300,
    easing: "ease",
    height: isOpen ? 'fit-content' : 0,
    "aria-hidden": !isOpen,
    sx: {
      overflow: 'hidden',
      variant: accordionPanelVariantPath,
      px: extraPadding ? 'sm' : 0
    },
    ref: ref
  }, props), {}, {
    children: _jsx("div", {
      sx: {
        py: 'sm',
        opacity: isOpen ? 1 : 0,
        visibility: isOpen ? 'visible' : 'hidden',
        transition: '0.3s',
        transitionProperty: 'opacity, visibility'
      },
      children: children
    })
  }));
});
AccordionPanel.displayName = 'AccordionPanel';
AccordionPanel.defaultProps = {
  extraPadding: false
};
export { AccordionPanel };